<template>
  <section :style="componentStyle" class="py-16" :id="sectionId">
    <v-container>
      <v-row
        justify="center"
      >
        <v-col
          v-for="(item, i) in items"
          :key="i"
          align="center"
          cols="12"
          md="4"
        >
          <div class="px-4">
            <div class="img-container">
              <img
                v-if="item.imgUrl"
                class="img-fluid"
                :src="item.imgUrl"
              />
              <v-icon
                v-else-if="item.icon"
                color="black"
                size="120"
              >{{item.icon}}</v-icon>
            </div>

            <div class="header-spacing">
              <h2>{{item.title}}</h2>
            </div>
            <div class="text-spacing">
              <p>{{item.text}}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
import promotionPageMixin from '../mixins/promotion-page'
function isBannerItem (item) {
  return item && (item.imgUrl || item.icon) && item.title && item.text
}
export default {
  mixins: [promotionPageMixin],
  props: {
    items: {
      type: Array,
      validator: (items) => {
        return items.every(isBannerItem)
      }
    }
  }
}
</script>
<style scoped>
.img-container{
  max-height: 120px;
}
.spacing {
  /* display: block; */
  padding-top: 95px;
  padding-bottom: 95px;
}

.header-spacing {
  display: block;
  width: 100%;
  padding-top: 36px;
  padding-bottom: 20px;
}

.header-spacing h2 {
  font-family: "Niveau Grotesk", "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 500;
}

.text-spacing {
  display: block;
  font-family: "Niveau Grotesk";
  font-size: 20px;
}

@media only screen and (max-width: 600px) {
  .spacing {
    padding: 20px;
  }
}
</style>
